import { render, staticRenderFns } from "./Cluster.vue?vue&type=template&id=6795fca6&"
import script from "./Cluster.vue?vue&type=script&lang=ts&"
export * from "./Cluster.vue?vue&type=script&lang=ts&"
import style0 from "./Cluster.vue?vue&type=style&index=0&id=6795fca6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports